import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map } from 'rxjs';
import { backendEndPointToken } from './app.config';

export const appointmentResolver: ResolveFn<any> = (route, state) => {
  const http = inject(HttpClient);
  const backendApiEndPoint = inject(backendEndPointToken);
  return http.get(`${backendApiEndPoint}/Appointment?_format=json`).pipe(map((e: any) => {
    return e.entry.map((f: any) => f.resource);
  }))
};
